import Text from "../../../components/ui/Text";
import { useAudioEffects } from "../../../hooks/use-audio-effects";
import clickSound from "../../../assets/audio/click.wav";
import { GameStats } from "../types";
import { LEVEL_SETTINGS } from "../constants";

interface Props {
  className?: string;
  isLevelComplete: boolean;
  stats: GameStats;
  isGameOver: boolean;
  isRunning: boolean;
  areAllLevelsFinished: boolean;
  gridSize: number;
  resetGame: () => void;
  nextLevel: () => void;
  startGame: () => void;
  setCurrentLevel: (l: number) => void;
}

const Scenarios = ({
  isGameOver,
  isLevelComplete,

  areAllLevelsFinished,
  stats,
  isRunning,
  nextLevel,
  startGame,
  resetGame,
  setCurrentLevel,
}: Props) => {
  const { playEffect } = useAudioEffects();

  // get next level info
  const nextLevelInfo = LEVEL_SETTINGS[stats.level + 1] || null;
  return (
    <div
      className={`absolute top-0 left-0 flex-col w-full h-full flex bg-black/50 rounded-[56px] items-center justify-center`}
    >
      {!areAllLevelsFinished && (
        <>
          {isGameOver && (
            <div className="text-center">
              <Text className="text-red-500 uppercase font-bold" size="3xl">
                GAME OVER
              </Text>
              <Text className="text-red-300 font-bold" size="md">
                No attempts left for this level.
              </Text>
            </div>
          )}

          {isLevelComplete && (
            <div className="text-center">
              <Text className="text-green-500 uppercase font-bold" size="3xl">
                LEVEL COMPLETED
              </Text>
              <Text className="text-green-300 font-bold" size="md">
                Great memory! Prepare for the next challenge.
              </Text>
            </div>
          )}

          {(isGameOver || isLevelComplete) && (
            <div className="grid grid-cols-3 gap-10 text-white mt-6">
              <div className="text-center gilroy-font">
                <Text>Points</Text>
                <Text size="xl">{stats.points}</Text>
              </div>

              <div className="text-center gilroy-font">
                <Text>Attempts left</Text>
                <Text size="xl">{stats.attemptsLeft}</Text>
              </div>

              <div className="text-center gilroy-font">
                <Text>Level</Text>
                <Text size="xl">{stats.level}</Text>
              </div>
            </div>
          )}

          {/* Show next level info if current level is not level 1 */}
          {nextLevelInfo && isLevelComplete && (
            <div className="text-center mt-4 text-white/80">
              <Text size="sm">
                Next level: {stats.level + 1} | Path length:{" "}
                {nextLevelInfo.pathLength} | Max miss clicks:{" "}
                {nextLevelInfo.maxMisses} | Max attempts:{" "}
                {nextLevelInfo.attempts}
              </Text>
            </div>
          )}

          {isGameOver && (
            <button
              onClick={resetGame}
              title="Reset game"
              className="bg-red-500 text-white text-2xl transition hover:bg-white hover:text-red-500 hover:scale-95 px-8 py-3 rounded-md mt-5"
            >
              Reset game
            </button>
          )}

          {isLevelComplete && (
            <button
              onClick={() => {
                nextLevel();
                playEffect(clickSound);
              }}
              title="Next-level"
              className="bg-green-500 text-white text-2xl transition hover:bg-white hover:text-green-500 hover:scale-95 px-8 py-3 rounded-md mt-5"
            >
              Go to next level
            </button>
          )}
        </>
      )}

      {areAllLevelsFinished && (
        <div>
          {" "}
          <div className="text-center mb-4 max-w-xl">
            <Text size="lg" className="text-white/80">
              You've completed all levels!
            </Text>
          </div>
          <button
            onClick={() => {
              setCurrentLevel(1);
              setTimeout(() => {
                startGame();
              }, 100);
              playEffect(clickSound);
            }}
            title="Start"
            className="bg-blue-500 text-white text-2xl transition hover:bg-white hover:text-blue-500 hover:scale-95 px-8 py-3 rounded-md mt-3"
          >
            Return to level 1
          </button>
        </div>
      )}

      {!isRunning && !isGameOver && !isLevelComplete && (
        <div className="text-center">
          {" "}
          <div className="text-center mb-4 max-w-xl">
            <Text size="lg" className="text-white/80">
              Remember the highlighted tiles and click them in any order.
              <span className="block text-red-200">
                Be careful: wrong clicks cost attempts!
              </span>
            </Text>
          </div>
          <button
            onClick={() => {
              startGame();
              playEffect(clickSound);
            }}
            title="Start"
            className="bg-blue-500 text-white text-2xl transition hover:bg-white hover:text-blue-500 hover:scale-95 px-8 py-3 rounded-md mt-3"
          >
            Start game
          </button>
        </div>
      )}
    </div>
  );
};

export default Scenarios;
